import { ArrowUp } from "lucide-react";
import { useLang } from "@/i18n";
import { openCookieBanner } from "@/lib/tracking";
import { scrollToSection } from "./Navbar";

export const Footer = () => {
  const { t } = useLang();

  const links = [
    { href: "#operazioni", label: t("nav_operations") },
    { href: "#approccio", label: t("nav_approach") },
    { href: "#numeri", label: t("nav_numbers") },
    { href: "#contatti", label: t("nav_contact") },
  ];

  return (
    <footer className="border-t border-amber-500/10 bg-[#0D0D10]">
      <div className="px-4 sm:px-8 lg:px-16 max-w-7xl mx-auto py-16 lg:py-24">
        <img
          src="/logo.png"
          alt="Capital Stone S.r.l."
          data-testid="footer-brand"
          className="h-14 sm:h-20 w-auto select-none"
        />

        <div className="flex flex-col md:flex-row md:items-end justify-between gap-10 mt-12">
          <div data-testid="footer-links" className="flex flex-wrap gap-x-8 gap-y-3">
            {links.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={scrollToSection(l.href)}
                className="text-xs tracking-[0.22em] uppercase text-zinc-500 hover:text-[#D4AF37] transition-colors duration-300"
              >
                {l.label}
              </a>
            ))}
            <a
              href="/privacy"
              data-testid="footer-privacy-link"
              className="text-xs tracking-[0.22em] uppercase text-zinc-500 hover:text-[#D4AF37] transition-colors duration-300"
            >
              Privacy Policy
            </a>
            <button
              type="button"
              data-testid="footer-cookie-settings"
              onClick={openCookieBanner}
              className="text-xs tracking-[0.22em] uppercase text-zinc-500 hover:text-[#D4AF37] transition-colors duration-300"
            >
              {t("ft_cookies")}
            </button>
          </div>
          <button
            data-testid="back-to-top-btn"
            onClick={() => (window.__lenis ? window.__lenis.scrollTo(0) : window.scrollTo({ top: 0, behavior: "smooth" }))}
            className="group flex items-center gap-3 text-xs tracking-[0.22em] uppercase text-zinc-500 hover:text-[#D4AF37] transition-colors duration-300"
          >
            {t("ft_top")}
            <span className="w-9 h-9 flex items-center justify-center border border-white/15 group-hover:border-amber-500/50 transition-colors duration-300">
              <ArrowUp size={14} className="transition-transform duration-300 group-hover:-translate-y-0.5" />
            </span>
          </button>
        </div>

        <div className="border-t border-white/5 mt-12 pt-8 flex flex-col sm:flex-row justify-between gap-4">
          <p data-testid="footer-copyright" className="text-xs text-zinc-600">
            © 2026 Capital Stone S.r.l. · P.IVA 14417030963 · REA MI-2781885 · {t("ft_rights")}
          </p>
          <p className="text-xs text-zinc-600">www.capitalstone.it · Milano</p>
        </div>
      </div>
    </footer>
  );
};
